import axios from 'axios';
import Qs from 'qs';
import store from '../store/store';
import commonFunc from '../common/commonFunction';
import i18n from '../i18n/i18n';
import eventBus from '../common/eventBus';

//Danh sách đối tượng cần xử lý cancel request
let cancelRequests = [];

/**
 * Lớp này dùng để thao tác với restful
 */
class AxiosHttpClient {
	/**
	 * config: AxiosRequestConfig
	 * @param config: {
	 * url?: string;
	 * method?: string;
	 * baseURL?: string;
	 * transformRequest?: AxiosTransformer | AxiosTransformer[];
	 * transformResponse?: AxiosTransformer | AxiosTransformer[];
	 * headers?: any;
	 * params?: any;
	 * paramsSerializer?: (params: any) => string;
	 * data?: any;
	 * timeout?: number;
	 * withCredentials?: boolean;
	 * adapter?: AxiosAdapter;
	 * auth?: AxiosBasicCredentials;
	 * responseType?: string;
	 * xsrfCookieName?: string;
	 * xsrfHeaderName?: string;
	 * onUploadProgress?: (progressEvent: any) => void;
	 * onDownloadProgress?: (progressEvent: any) => void;
	 * maxContentLength?: number;
	 * validateStatus?: (status: number) => boolean;
	 * maxRedirects?: number;
	 * httpAgent?: any;
	 * httpsAgent?: any;
	 * proxy?: AxiosProxyConfig | false;
	 * cancelToken?: CancelToken;
	 * }
	 * @param method: POST, PUT, GET, DELTE
	 * @param isShowLoading: có cho loading hay không, hiển thị loading cho người dùng
	 * @param isCancelRequest: có cho phép hủy request cùng url và method hay không
	 * @param contenType: application/json, application/x-www-form-urlencoded, multipart/form-data
	 */
	async postAsync(config, isShowLoading = false, isCancelRequest = true, contenType = ApplicationJson) {
		const me = this;
		return await me.requestAsync(config, POST, isShowLoading, isCancelRequest, contenType);
	}

	/**
	 * config: AxiosRequestConfig
	 * @param config: {
	 * url?: string;
	 * method?: string;
	 * baseURL?: string;
	 * transformRequest?: AxiosTransformer | AxiosTransformer[];
	 * transformResponse?: AxiosTransformer | AxiosTransformer[];
	 * headers?: any;
	 * params?: any;
	 * paramsSerializer?: (params: any) => string;
	 * data?: any;
	 * timeout?: number;
	 * withCredentials?: boolean;
	 * adapter?: AxiosAdapter;
	 * auth?: AxiosBasicCredentials;
	 * responseType?: string;
	 * xsrfCookieName?: string;
	 * xsrfHeaderName?: string;
	 * onUploadProgress?: (progressEvent: any) => void;
	 * onDownloadProgress?: (progressEvent: any) => void;
	 * maxContentLength?: number;
	 * validateStatus?: (status: number) => boolean;
	 * maxRedirects?: number;
	 * httpAgent?: any;
	 * httpsAgent?: any;
	 * proxy?: AxiosProxyConfig | false;
	 * cancelToken?: CancelToken;
	 * }
	 * @param method: POST, PUT, GET, DELTE
	 * @param isShowLoading: có cho loading hay không, hiển thị loading cho người dùng
	 * @param isCancelRequest: có cho phép hủy request cùng url và method hay không
	 * @param contenType: application/json, application/x-www-form-urlencoded, multipart/form-data
	 */
	async putAsync(config, isShowLoading = false, isCancelRequest = true, contenType = ApplicationJson) {
		const me = this;
		return await me.requestAsync(config, PUT, isShowLoading, isCancelRequest, contenType);
	}

	/**
	 * config: AxiosRequestConfig
	 * @param config: {
	 * url?: string;
	 * method?: string;
	 * baseURL?: string;
	 * transformRequest?: AxiosTransformer | AxiosTransformer[];
	 * transformResponse?: AxiosTransformer | AxiosTransformer[];
	 * headers?: any;
	 * params?: any;
	 * paramsSerializer?: (params: any) => string;
	 * data?: any;
	 * timeout?: number;
	 * withCredentials?: boolean;
	 * adapter?: AxiosAdapter;
	 * auth?: AxiosBasicCredentials;
	 * responseType?: string;
	 * xsrfCookieName?: string;
	 * xsrfHeaderName?: string;
	 * onUploadProgress?: (progressEvent: any) => void;
	 * onDownloadProgress?: (progressEvent: any) => void;
	 * maxContentLength?: number;
	 * validateStatus?: (status: number) => boolean;
	 * maxRedirects?: number;
	 * httpAgent?: any;
	 * httpsAgent?: any;
	 * proxy?: AxiosProxyConfig | false;
	 * cancelToken?: CancelToken;
	 * }
	 * @param method: POST, PUT, GET, DELTE
	 * @param isShowLoading: có cho loading hay không, hiển thị loading cho người dùng
	 * @param isCancelRequest: có cho phép hủy request cùng url và method hay không
	 * @param contenType: application/json, application/x-www-form-urlencoded, multipart/form-data
	 */
	async deleteAsync(config, isShowLoading = false, isCancelRequest = true, contenType = ApplicationJson) {
		const me = this;
		return await me.requestAsync(config, DELETE, isShowLoading, isCancelRequest, contenType);
	}

	/**
	 * config: AxiosRequestConfig
	 * @param config: {
	 * url?: string;
	 * method?: string;
	 * baseURL?: string;
	 * transformRequest?: AxiosTransformer | AxiosTransformer[];
	 * transformResponse?: AxiosTransformer | AxiosTransformer[];
	 * headers?: any;
	 * params?: any;
	 * paramsSerializer?: (params: any) => string;
	 * data?: any;
	 * timeout?: number;
	 * withCredentials?: boolean;
	 * adapter?: AxiosAdapter;
	 * auth?: AxiosBasicCredentials;
	 * responseType?: string;
	 * xsrfCookieName?: string;
	 * xsrfHeaderName?: string;
	 * onUploadProgress?: (progressEvent: any) => void;
	 * onDownloadProgress?: (progressEvent: any) => void;
	 * maxContentLength?: number;
	 * validateStatus?: (status: number) => boolean;
	 * maxRedirects?: number;
	 * httpAgent?: any;
	 * httpsAgent?: any;
	 * proxy?: AxiosProxyConfig | false;
	 * cancelToken?: CancelToken;
	 * }
	 * @param method: POST, PUT, GET, DELTE
	 * @param isShowLoading: có cho loading hay không, hiển thị loading cho người dùng
	 * @param isCancelRequest: có cho phép hủy request cùng url và method hay không
	 * @param contenType: application/json, application/x-www-form-urlencoded, multipart/form-data
	 */
	async getAsync(config, isShowLoading = false, isCancelRequest = true, contenType = ApplicationJson) {
		const me = this;
		return await me.requestAsync(config, GET, isShowLoading, isCancelRequest, contenType);
	}

	/**
	 * config: AxiosRequestConfig
	 * @param config: {
	 * url?: string;
	 * method?: string;
	 * baseURL?: string;
	 * transformRequest?: AxiosTransformer | AxiosTransformer[];
	 * transformResponse?: AxiosTransformer | AxiosTransformer[];
	 * headers?: any;
	 * params?: any;
	 * paramsSerializer?: (params: any) => string;
	 * data?: any;
	 * timeout?: number;
	 * withCredentials?: boolean;
	 * adapter?: AxiosAdapter;
	 * auth?: AxiosBasicCredentials;
	 * responseType?: string;
	 * xsrfCookieName?: string;
	 * xsrfHeaderName?: string;
	 * onUploadProgress?: (progressEvent: any) => void;
	 * onDownloadProgress?: (progressEvent: any) => void;
	 * maxContentLength?: number;
	 * validateStatus?: (status: number) => boolean;
	 * maxRedirects?: number;
	 * httpAgent?: any;
	 * httpsAgent?: any;
	 * proxy?: AxiosProxyConfig | false;
	 * cancelToken?: CancelToken;
	 * }
	 * @param method: POST, PUT, GET, DELTE
	 * @param isShowLoading: có cho loading hay không, hiển thị loading cho người dùng
	 * @param isCancelRequest: có cho phép hủy request cùng url và method hay không
	 * @param contenType: application/json, application/x-www-form-urlencoded, multipart/form-data
	 */
	async patchAsync(config, isShowLoading = false, isCancelRequest = true, contenType = ApplicationJson) {
		const me = this;
		return await me.requestAsync(config, PATCH, isShowLoading, isCancelRequest, contenType);
	}

	/**
	 * config: AxiosRequestConfig
	 * @param config: {
	 * url?: string;
	 * method?: string;
	 * baseURL?: string;
	 * transformRequest?: AxiosTransformer | AxiosTransformer[];
	 * transformResponse?: AxiosTransformer | AxiosTransformer[];
	 * headers?: any;
	 * params?: any;
	 * paramsSerializer?: (params: any) => string;
	 * data?: any;
	 * timeout?: number;
	 * withCredentials?: boolean;
	 * adapter?: AxiosAdapter;
	 * auth?: AxiosBasicCredentials;
	 * responseType?: string;
	 * xsrfCookieName?: string;
	 * xsrfHeaderName?: string;
	 * onUploadProgress?: (progressEvent: any) => void;
	 * onDownloadProgress?: (progressEvent: any) => void;
	 * maxContentLength?: number;
	 * validateStatus?: (status: number) => boolean;
	 * maxRedirects?: number;
	 * httpAgent?: any;
	 * httpsAgent?: any;
	 * proxy?: AxiosProxyConfig | false;
	 * cancelToken?: CancelToken;
	 * }
	 * @param method: POST, PUT, GET, DELTE
	 * @param isShowLoading: có cho loading hay không, hiển thị loading cho người dùng
	 * @param isCancelRequest: có cho phép hủy request cùng url và method hay không
	 * @param contenType: application/json, application/x-www-form-urlencoded, multipart/form-data
	 */
	async requestAsync(config, method, isShowLoading = false, isCancelRequest = true, contenType = ApplicationJson) {
		const me = this;
		try {
			commonFunc.infoLogging(`requestAsync::url::${config.url}`);

			//Cập nhật các tham số của headers
			let expiredJwt = me._processHeaders(config, contenType);
			if (expiredJwt && expiredJwt.status === 401) {
				// Trả về một Promise.reject để axios interceptor có thể bắt được
				eventBus.emit('onExpiredJwt', expiredJwt);
				return;
			}

			//Cập nhật data
			me._processDataOrParams(config, method, contenType);

			//Lấy key trong danh sách hủy request
			let key = me._getKey(config);

			//Thêm cancelrequest vào danh sách hủy
			let cancelRequest = me._addCancelRequest(config, key, isCancelRequest);

			//Hiển thị loading
			me._setLoading(isShowLoading, true);

			//Thực hiện gọi service
			let result = await axios(config);

			//Log kết quả
			commonFunc.infoLogging('requestAsync::result::begin');
			commonFunc.infoLogging(result);
			commonFunc.infoLogging('requestAsync::result::end');

			//Ẩn loading
			me._setLoading(isShowLoading, false);

			//Hủy request
			me._removeRequest(cancelRequest, 'finish');

			//Trả kết quả xử lý thành công
			if (result) {
				//Điều hướng sang màn hình lỗi
				if (result.status > 500 && me.$router) {
					me.$router.replace({ path: '/pages/error-500' });
					return;
				}

				//Xử lý riêng cho trường hợp đặc biệt là tải file, in file,...
				if (result.headers && result.headers['x-download-file']) {
					return result;
				}

				//Mã lỗi 422 là lỗi nghiệp vụ được trả về từ backend
				if (result.status >= 200 && result.status < 400) {
					return result.data;
				}

				//Trả kết quả mặc định
				return result;
			}

			//Trường hợp request bị hủy nên trả về empty dữ liệu
			return {
				Success: false,
				Data: null,
				Code: 0,
				Message: i18n.t('i18nCommon.CancelRequest'),
				MessageDev: ''
			};
		} catch (error) {
			//Ẩn loading
			me._setLoading(isShowLoading, false);

			//Axios 1.x: request bị cancel throw CanceledError vào catch, không có error.response
			if (!error || (axios && axios.isCancel(error))) {
				return {
					Success: false,
					Data: null,
					Code: 0,
					Message: i18n.t('i18nCommon.CancelRequest'),
					MessageDev: ''
				};
			}

			//Log lỗi
			commonFunc.errorLogging('requestAsync::error::', error.response);

			//Điều hướng sang màn hình lỗi
			if (me.$router) {
				me.$router.replace({ path: '/pages/error-500' });
			}

			//Trả kết quả lỗi — error.response có thể undefined nếu network error hoặc timeout
			return error.response ? error.response.data : null;
		}
	}

	/**
	 * config: AxiosRequestConfig
	 * Chi tiết các thông tin trong config
	 * @param {
	 * url?: string;
	 * method?: string;
	 * baseURL?: string;
	 * transformRequest?: AxiosTransformer | AxiosTransformer[];
	 * transformResponse?: AxiosTransformer | AxiosTransformer[];
	 * headers?: any;
	 * params?: any;
	 * paramsSerializer?: (params: any) => string;
	 * data?: any;
	 * timeout?: number;
	 * withCredentials?: boolean;
	 * adapter?: AxiosAdapter;
	 * auth?: AxiosBasicCredentials;
	 * responseType?: string;
	 * xsrfCookieName?: string;
	 * xsrfHeaderName?: string;
	 * onUploadProgress?: (progressEvent: any) => void;
	 * onDownloadProgress?: (progressEvent: any) => void;
	 * maxContentLength?: number;
	 * validateStatus?: (status: number) => boolean;
	 * maxRedirects?: number;
	 * httpAgent?: any;
	 * httpsAgent?: any;
	 * proxy?: AxiosProxyConfig | false;
	 * cancelToken?: CancelToken;
	 * }
	 */
	_processDataOrParams(config, method, contenType = ApplicationJson) {
		if (!config) return;

		//Xử lý method
		config.method = method;

		//Xử lý tham số đối với phương thức GET, DELETE
		if (method == GET || method == DELETE) {
			//Không cần làm gì
		}

		//Xử lý tham số đối với phương thức POST, PUT, kiểu form-url-encoded
		if ((method == POST || method == PATCH || method == PUT) && contenType == FormUrlEncoded) {
			config.data = Qs.stringify(config.data || {});
		}

		//Xử lý tham số đối với phương thức POST, PUT, kiểu multipart
		if ((method == POST || method == PATCH || method == PUT) && contenType == FormMultiPart) {
			//Không cần làm gì
		}
	}

	/**
	 * config: AxiosRequestConfig
	 * Chi tiết các thông tin trong config
	 * @param {
	 * url?: string;
	 * method?: string;
	 * baseURL?: string;
	 * transformRequest?: AxiosTransformer | AxiosTransformer[];
	 * transformResponse?: AxiosTransformer | AxiosTransformer[];
	 * headers?: any;
	 * params?: any;
	 * paramsSerializer?: (params: any) => string;
	 * data?: any;
	 * timeout?: number;
	 * withCredentials?: boolean;
	 * adapter?: AxiosAdapter;
	 * auth?: AxiosBasicCredentials;
	 * responseType?: string;
	 * xsrfCookieName?: string;
	 * xsrfHeaderName?: string;
	 * onUploadProgress?: (progressEvent: any) => void;
	 * onDownloadProgress?: (progressEvent: any) => void;
	 * maxContentLength?: number;
	 * validateStatus?: (status: number) => boolean;
	 * maxRedirects?: number;
	 * httpAgent?: any;
	 * httpsAgent?: any;
	 * proxy?: AxiosProxyConfig | false;
	 * cancelToken?: CancelToken;
	 * }
	 */
	_processHeaders(config, contenType = ApplicationJson) {
		//Không có cấu hình
		if (!config) return;

		//Lấy dữ liệu của headers
		let headers = config.headers || {};

		//Cắm cờ cho biết tải file từ ứng dụng
		headers['x-download-file'] = 'false';

		//Cập nhật Authorization
		let auth = commonFunc.getJWTToken();
		if (auth) {
			//Kiểm tra JWT token còn hạn không
			if (
				window.__env &&
				window.__env.appSetting &&
				window.__env.appSetting.isCheckExpiredToken &&
				!commonFunc.isValidJWTToken(auth)
			) {
				//Tạo lỗi 401 Unauthorized để kích hoạt xử lý logout trong authService
				return {
					status: 401,
					data: {
						Success: false,
						Message: 'Hết phiên làm việc'
					}
				};
			}

			//Cập nhật Authorization
			headers['Authorization'] = `Bearer ${auth}`;
		}

		//Bổ sung thông tin của SubscriberCode để backend có thể xác định đúng công ty đang làm việc
		//Mã SubscriberCode (MST/CCCD) được lưu trong localStorage và gửi cùng mỗi request
		//giúp người dùng có thể làm việc trên nhiều công ty khác nhau nếu được cấp quyền
		let subscriberCode = localStorage.getItem('SubscriberCode');
		if (subscriberCode) {
			headers['SubscriberCode'] = subscriberCode;
		}

		//Mã bảo mật của hệ thống
		headers['Ue6ChgtmXQGMHvZw4BURFQxpg'] = 'Zv9RaKV77DtHRNjUSRK996UX6';

		//Content type
		headers['Content-Type'] = contenType;

		//Có hỗ trợ đa ngôn ngữ hay không
		let lang = 'vi';
		if (window.__env && window.__env.authConfig && window.__env.authConfig.isMultipleLanguage) {
			lang = commonFunc.getLanguageFromStorage();
		} else {
			lang = 'vi';
		}

		//Nếu ngôn ngữ thay đổi thì cập nhật lại ngôn ngữ
		if (i18n && i18n.locale !== lang) {
			//Thay đổi ngôn ngữ
			i18n.locale = lang;
			//Lưu lại ngôn ngữ sử dụng
			commonFunc.setLanguageToStorage(lang);
		}

		//Bổ sung ngôn ngữ cho header
		headers['Accept-Language'] = lang;

		//Client id truy cập vào hệ thống Inbot
		if (!headers.hasOwnProperty('ClientId')) {
			headers['ClientId'] = window.__env.authConfig.client_id;
		}

		//Client Secret để bảo mật truy cập vào hệ thống inbot
		headers['Client-Secret'] = window.__env.authConfig.client_secret;

		//Cập nhật lại header
		config.headers = headers;
	}

	/**
	 * Lấy key để cancel request theo config
	 * @param config
	 */
	_getKey(config) {
		if (!config) return '';
		return `${config.url}_${config.method}`;
	}

	/**
	 * Hàm này cho phép hủy request
	 * @param cancelRequest
	 */
	_removeRequest(cancelRequest, from) {
		try {
			if (!cancelRequest) return;

			//Hủy request
			if (cancelRequest.Value) {
				cancelRequest.Value.cancel();
			}

			//Xóa giá trị trong danh sách chờ hủy
			cancelRequests = cancelRequests.filter(n => {
				return n.Key != cancelRequest.Key || (n.Key == cancelRequest.Key && n.Time != cancelRequest.Time);
			});
		} catch (ex) {
			commonFunc.errorLogging('_cancelRequest::error:', ex);
		}
	}

	/**
	 * Thêm vào danh sách hủy request
	 * @param config
	 * @param key
	 * @param isCancelRequest
	 */
	_addCancelRequest(config, key, isCancelRequest) {
		const me = this;
		try {
			//Lấy các request có key và cần hủy
			let requests = cancelRequests.filter(n => n.Key == key && n.IsCancelRequest == true);
			if (requests != null && requests.length > 0) {
				requests.forEach(request => me._removeRequest(request, 'add'));
			}

			//cancel token
			let cancelTokenSource = axios.CancelToken.source();

			//Cập nhật vào config
			config.cancelToken = cancelTokenSource.token;

			//Tạo yêu cầu hủy request
			let cancelRequest = {
				Key: key,
				Value: cancelTokenSource,
				Time: new Date().getTime(),
				IsCancelRequest: isCancelRequest
			};

			//Thêm vào danh sách chờ hủy request
			cancelRequests.push(cancelRequest);

			//Trả về tham số cancel request
			return cancelRequest;
		} catch (ex) {
			commonFunc.errorLogging('_addCancelRequest::error::', ex);
		}

		return null;
	}

	/**
	 * Hủy tất cả yêu cầu
	 */
	_cancelAllRequest() {
		cancelRequests.forEach(cancelRequest => {
			cancelRequest.Value.cancel();
		});
	}

	/**
	 * Hàm này dùng để update trạng thái loading trong global state
	 * @param isShowLoading có cho loading hay không, hiển thị loading cho người dùng
	 * @param isLoading
	 */
	_setLoading(isShowLoading, isLoading) {
		commonFunc.setLoading(isShowLoading, isLoading);
	}
}

//Instance của axios client
export default new AxiosHttpClient();

//Các method của http
export const POST = 'POST';
export const PUT = 'PUT';
export const DELETE = 'DELETE';
export const GET = 'GET';
export const PATCH = 'PATCH';

//Content-type
export const ApplicationJson = 'application/json';
export const FormUrlEncoded = 'application/x-www-form-urlencoded';
export const FormMultiPart = 'multipart/form-data';
